"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var processData = function processData(_ref) {
  var _target$sys, _target$sys$contentTy, _target$sys$contentTy2, _target$fields;
  var data = _ref.data,
    content = _ref.content,
    factories = _ref.factories;
  var target = data.target;
  var contentType = target === null || target === void 0 ? void 0 : (_target$sys = target.sys) === null || _target$sys === void 0 ? void 0 : (_target$sys$contentTy = _target$sys.contentType) === null || _target$sys$contentTy === void 0 ? void 0 : (_target$sys$contentTy2 = _target$sys$contentTy.sys) === null || _target$sys$contentTy2 === void 0 ? void 0 : _target$sys$contentTy2.id;
  var site = target === null || target === void 0 ? void 0 : (_target$fields = target.fields) === null || _target$fields === void 0 ? void 0 : _target$fields.site;
  var factory = factories[contentType];
  if (factory) {
    return {
      target: site !== null && site !== void 0 && site.includes(process.env.NEXT_PUBLIC_SITE) ? factory(target, content) : null
    };
  }
  return data;
};
var processNode = function processNode(_ref2) {
  var node = _ref2.node,
    depth = _ref2.depth,
    maxDepth = _ref2.maxDepth,
    factories = _ref2.factories;
  var data = node.data,
    content = node.content;
  if (depth > maxDepth || !content) return node;
  return _objectSpread(_objectSpread({}, node), {}, {
    data: data ? processData({
      data: data,
      content: content,
      factories: factories
    }) : data,
    content: content.map(function (contentNode) {
      return processNode({
        node: contentNode,
        depth: depth + 1,
        maxDepth: maxDepth,
        factories: factories
      });
    })
  });
};
var processRichText = function processRichText(_ref3) {
  var document = _ref3.document,
    _ref3$depth = _ref3.depth,
    depth = _ref3$depth === void 0 ? 0 : _ref3$depth,
    _ref3$maxDepth = _ref3.maxDepth,
    maxDepth = _ref3$maxDepth === void 0 ? 4 : _ref3$maxDepth,
    factories = _ref3.factories;
  return _objectSpread(_objectSpread({}, document), {}, {
    content: document.content.map(function (node) {
      return processNode({
        node: node,
        depth: depth + 1,
        maxDepth: maxDepth,
        factories: factories
      });
    })
  });
};
var _default = processRichText;
exports["default"] = _default;